import React from 'react';

import {
  composeCoverageDeltasByGroupNames,
  composeGlobalDeltas,
  type CoverageSummaryProps,
} from '../helpers/coverage-summary.utils';

export const useGetCoverageSummaryDeltas = ({
  policyDetails,
  progressData,
}: CoverageSummaryProps) => {
  const mergedGlobals = composeGlobalDeltas({ policyDetails, progressData });

  const mergedCoveragesByGroups = React.useMemo(
    () =>
      composeCoverageDeltasByGroupNames({
        policyDetails,
        progressData,
      }),
    [policyDetails, progressData]
  );

  return { mergedCoveragesByGroups, mergedGlobals };
};
